module.exports = __webpack_public_path__ + "static/media/Adv_photo_02_240603.a960363d.webp";